import "./ReferencesAndLinks.module.css";
import Header from "@/reusable_sections/Header";
import Kundenvertrauen from "./sections/Kundenvertrauen";
import ResourcesAndLinks from "./sections/ResourcesAndLinks";
import Links from "./sections/Links";
import Referenzen from "./sections/Referenzen";
import Footer from "@/reusable_sections/Footer";
export default function ReferencesAndLinksPage() {
  return <div>
      <Header />
      <Kundenvertrauen />
      <Referenzen />
      <ResourcesAndLinks />
      <Links />
      <Footer />
    </div>;
}